import React from "react";
import useApp from "../../hooks/useApp";
import "./styles.scss";
import { getSessionStorage } from "../../utils/storageUtils";
import { HEADER, STORAGE_KEYS } from "../../constants";
import { TarabutLoader } from "../../assets/gif";
import { getBankFaviconAsSvg } from "../../utils/svgUtils";
import { TarabutFavicon, WarningInfoCircle } from "../../assets/svgs";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import NoticeCard from "../NoticeCard";

const CustomLoader = ({ visible, providerId, isPingPongLoader }) => {
  const { tenantConfig } = useApp();
  const productSlug = getSessionStorage(HEADER.PRODUCT_SLUG);
  const loader = getSessionStorage(STORAGE_KEYS.LOADER);
  const secondaryBankFavicon = getBankFaviconAsSvg(providerId);
  const location = useLocation();
  const { t } = useTranslation();
  const { pathname } = location;

  const routeName = pathname.split("/")[1];

  const handleLoadingText = () => {
    switch (productSlug) {
      case "fleet-financing": {
        return (
          <>
            <p className="loading-description" style={{ textAlign: "center" }}>
              {t(`${routeName}.we_are_connecting_your_bank`)}
            </p>
            <p className="loading-heading" style={{ textAlign: "center" }}>
              {t(`${routeName}.connecting_response_time`)}
            </p>
            <NoticeCard
              containerStyle={{ marginTop: "32px" }}
              contentStyle={{ alignItems: "center" }}
              backgroundColor={"warning-50"}
              icon={WarningInfoCircle}
              descriptionText={`${routeName}.keep_this_page_open`}
            />
            <p className="encrypted_text">
              {t(`${routeName}.your_data_encraypted`)}
            </p>
          </>
        );
      }
      default:
        return (
          <>
            {" "}
            <p className="loading-heading">
              {t(`${routeName}.connecting_your_bank`)}
            </p>
            <p className="loading-description">
              {t(`${routeName}.loading_your_data`)}
            </p>
          </>
        );
    }
  };
  if (!visible) return null;
  if (!isPingPongLoader) {
    return (
      <div
        className="custom-loader-container"
        style={{
          backgroundColor: tenantConfig?.mobile_loader?.content?.bg_color,
        }}
      >
        <img
          src={loader ? loader : TarabutLoader}
          alt="loader"
          className="custom-loader-image"
        />
      </div>
    );
  }
  if (isPingPongLoader) {
    return (
      <div className="link-bank-ping-pong-container">
        <div
          className={`ping-pong-icons-container ${true ? "is-loading" : ""}`}
        >
          <img
            src={TarabutFavicon}
            alt="Tarabut Logo"
            className="icon first-image"
          />
          {secondaryBankFavicon ? (
            <img
              src={secondaryBankFavicon}
              alt={providerId}
              className="icon second-image"
            />
          ) : null}
        </div>
        {handleLoadingText()}
      </div>
    );
  }
};

export default CustomLoader;
